import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { FolderData } from '../hooks/useFetchAssetsAndFoldersQuery';
import { Asset, AssetSubfolder } from '../types';

export interface AssetsQueryContextState {
  assetCount: number; // the number of loaded results (accumulated number if appending, otherwise the current page of results)
  assetCountTotal: number; // the total number of available results (all pages combined) for the given fetch parameters
  assetPage: number; // logical page (1, 2, 3, ...)
  assetPageSize: number;
  currentFolder: FolderData['folderData'] | null;
  rootFolderId: number;
  folderId: number;
  folders: AssetSubfolder[];
  assets: Asset[];
  isLoading: boolean;
  hasError: boolean;
  setFolderId: (folderId: number) => void;
  refetch: () => void;
  isPanel: boolean;
}

const assetsQueryContextDefaults: AssetsQueryContextState = {
  assetCount: 0,
  assetCountTotal: 0,
  assetPage: 1,
  assetPageSize: 20,
  currentFolder: null,
  rootFolderId: 0,
  folderId: 0,
  folders: [],
  assets: [],
  isLoading: false,
  hasError: false,
  setFolderId: () => undefined,
  refetch: noop,
  isPanel: false,
};

export const AssetsQueryContext = createContext<AssetsQueryContextState>(
  assetsQueryContextDefaults,
);

export const useAssetsQueryContext = () => useContext(AssetsQueryContext);
